import { useEffect } from "react";

import { NotificationType } from "@transfr-inc/dashboard-components";

import { useNotificationContext } from "@contexts/notification-context";
import { registerRateLimitHandler } from "@lib/react-query/rate-limit-notifier";

const RATE_LIMIT_MESSAGE = "Too many requests. Please try again shortly.";

/**
 * Shows an error toast when a server request is rejected for rate limiting
 * (HTTP 429). The query client detects the 429 outside the React tree and
 * routes it here so the message renders through the app's notification stack.
 *
 * Mount once, inside `NotificationProvider`.
 */
export function useRateLimitToast() {
  const { addNotification, closeNotificationTimeout } =
    useNotificationContext();

  useEffect(() => {
    return registerRateLimitHandler(() => {
      const id = addNotification({
        type: NotificationType.error,
        message: RATE_LIMIT_MESSAGE,
      });
      closeNotificationTimeout(id);
    });
  }, [addNotification, closeNotificationTimeout]);
}
